<template>
    <div
        @click="open = !open"
        :class="[
            'border border-gray-200 rounded-2xl cursor-pointer !transition-all !duration-300',
            { 'hover:shadow-lg': !withoutShadow },
            { 'shadow-lg': open && !withoutShadow },
        ]"
    >
        <div class="flex flex-col">
            <div class="'p-6 text-sm sm:text-xl">
                <div class="flex flex-row justify-between p-4 sm:p-6">
                    <div
                        :class="[
                            'text-sm sm:text-xl font-semibold transition-all duration-100',
                            { 'text-primary': open && !darkFont },
                            { 'text-primaryText': !open || darkFont },
                        ]"
                    >
                        {{ question }}
                    </div>
                    <div class="flex justify-center items-center">
                        <PlusIcon v-if="!open" class="h-6 text-primary" />
                        <MinusIcon v-if="open" class="h-6 text-primary" />
                    </div>
                </div>
            </div>

            <div
                v-show="open"
                class="px-4 pb-4 sm:px-6 sm:pb-6 text-gray-500 text-sm sm:text-lg"
            >
                {{ answer }}
            </div>
        </div>
    </div>
</template>
<script>
import { PlusIcon, MinusIcon } from "@heroicons/vue/outline";

export default {
    components: {
        PlusIcon,
        MinusIcon,
    },

    props: {
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: String,
            required: true,
        },
        withoutShadow: {
            type: Boolean,
        },
        shouldBeOpen: {
            type: Boolean,
            default: false,
        },
        darkFont: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            open: this.shouldBeOpen,
        };
    },
};
</script>
